import './style.less';

export default class HelpModalCtrl {
    constructor(close) {
        this.close = close;
    }

    close () {
        this.close();
    }

}


// WEBPACK FOOTER //
// ./src/app/modals/help/ctrl.js